import useCheckPC from "@repo/hooks/utils/useCheckPC";
import classNames from "classnames";
import React from "react";
import { Link } from "react-router-dom";

import SVGLogo from "@components/atoms/Icon/svg/logo.svg?react";

import useLayout from "@hooks/reducerHooks/useLayout";
import useCheckLocation from "@hooks/useCheckLocation";

import { URLS } from "@const/urls";

interface IProps {
  goToUrl?: string;
  className?: string | classNames.ArgumentArray;
}

function Logo({ goToUrl = URLS.HOME, className }: IProps) {
  const { isHeaderOpen, isCartOpen, isSearchOpen, closeHeader, closeSearch } = useLayout();
  const { isPC } = useCheckPC();
  const { isEventPage } = useCheckLocation();

  return (
    <div className={classNames("mx-auto my-0", className)}>
      <Link
        onClick={() => {
          isHeaderOpen && closeHeader();
          isSearchOpen && closeSearch();
        }}
        to={goToUrl}
      >
        <SVGLogo
          fill={classNames(
            !isPC && isCartOpen && "black",
            isSearchOpen && "black",
            isHeaderOpen || isEventPage ? "rgb(var(--text-quaternary))" : "rgb(var(--text-primary))",
          )}
        />
      </Link>
    </div>
  );
}

export default Logo;
